import {
  CONFERENCE_LOADING,
  GET_CONFERENCES,
  GET_CONFERENCE,
} from '../actions/types';

const initialState = {
  conference: {},
  conferences: [],
  loading: false
};

export default function FuncState(state = initialState, action) {
  switch (action.type) {
    case GET_CONFERENCE: 
    return {
      ...state,
      conference: action.payload,
      loading: false
    };
    case GET_CONFERENCES: 
    return {
      ...state,
      conferences: action.payload,
      loading: false
    };
    case CONFERENCE_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
}
